import { createSlice } from "redux-starter-kit";
import { getPreferencesFromCookies } from "./api/initialisePreferences";

export const preferencesSlice = createSlice({
  slice: "preferences",
  initialState: getPreferencesFromCookies(),
  reducers: {
    set: (state, action) => {
      const { key, value } = action.payload;
      state[key] = [value];
    },
    merge: (state, action) => {
      const newPreferences = action.payload.preferences || {};
      const newState = { ...state, ...newPreferences };
      return newState;
    },

    toggle: (state, action) => {
      const { key, value, preference } = action.payload;
      state[key] = state[key] || [];
      state[key] = toggleArrItem(state[key], value);
      if (preference.noEmptySelection && !state[key].length) state[key] = [value];
    },
  },
});

const toggleArrItem = (arr, item) => (arr.includes(item) ? removeItem(arr, item) : addItem(arr, item));
const removeItem = (arr, item) => arr.filter((i) => i !== item);
const addItem = (arr, item) => arr.concat(item);
